import { render, staticRenderFns } from "./DfpAd.vue?vue&type=template&id=1fb517fc&scoped=true&"
import script from "./DfpAd.vue?vue&type=script&lang=js&"
export * from "./DfpAd.vue?vue&type=script&lang=js&"
import style0 from "./DfpAd.vue?vue&type=style&index=0&id=1fb517fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb517fc",
  null
  
)

export default component.exports